import React, { useState, useContext, useMemo } from "react";
import Breadcrumbs from "../components/breadcrumbs";
import Header from "../components/header";
import Steps from "../components/steps";
import Modal from "react-overlays/Modal";
import Icon from "../components/icons";
import { getDayDesc, slugifyEventTitle } from "../utils/utility";
import {
  useCart,
  useSetBooking,
  useConfermaAcquisto,
} from "../hooks/useQueryCart";
import UserContext from "../context/user";
import Seo from "../components/seo";
import { Link } from "react-router-dom";
import { useNavigazione } from "../context/navigazione";
import { ECOMMERCE_MODE } from "../utils/constants";
import { useQueryClient } from "@tanstack/react-query";
import classNames from "classnames";

const Carrello = () => {
  const { callApi, userProfile } = useContext(UserContext);
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const { getPathByTemplate, mode } = useNavigazione();
  const ordiniLink = getPathByTemplate("ordini");
  const [placement, setPlacement] = useState("");
  const bigliettiPrenotazioniLink = getPathByTemplate("bigliettiPrenotazioni");
  const [submitting, setSubmitting] = useState(false);
  const [removing, setRemoving] = useState(false);
  const linkProgramma = getPathByTemplate("programma");

  const breadcrumbs = useMemo(() => {
    return [
      {
        label: "Home",
        link: "/",
      },
      {
        label: "Biglietti e prenotazioni",
        link: bigliettiPrenotazioniLink,
      },
      {
        label: "Completa l'acquisto",
      },
    ];
  }, [bigliettiPrenotazioniLink]);
  //const ordiniLink = getPathByTemplate("ordini");
  const { data: cart, isLoading } = useCart();
  const isBookFail = cart?.book?.some((item) => item.status === "fail");
  const onHide = () => {
    setShowModal(false);
    setPlacement(null);
  };

  const removeBooking = useSetBooking();
  const confermaAcquisto = useConfermaAcquisto();
  const onRemoveBooking = async (idSlot) => {
    setRemoving(idSlot);
    try {
      const payload = {
        id_slot: idSlot,
        titolo: [],
      };
      await removeBooking.mutateAsync(payload);
    } catch (err) {
      console.error("Error: ", err);
    }
    setRemoving(false);
  };

  const handleSubmit = async (e) => {
    console.log("submit form acquisto");
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = await callApi("/api/ecommerce/checkout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log(data);
      if (data?.message !== "Success") {
        setPlacement("Servizio attualmente non disponibile");
        setShowModal(true);
      } else {
        if (data.data?.url_pagamento) {
          //queryClient.setQueryData(["cart", userProfile?.username], undefined);
          window.location.href = data.data.url_pagamento;
        } else {
          const params = {
            codice_ordine: cart.id_carrello,
            stato: "OK",
            codice_voucher: "1111" + Math.floor(Math.random() * 10000),
          };
          const response = await confermaAcquisto.mutateAsync(params);
          console.log(response);
          if (response?.message === "Success") {
            const message = (
              <>
                <h2>Prenotazioni confermate con successo</h2>
                <p>
                  A breve saranno disponibile alla pagina{" "}
                  <Link to={ordiniLink}>i tuoi ordini</Link>
                </p>
              </>
            );
            setPlacement(message);
          } else {
            const message = (
              <>
                <h2>Si è verificato un errore</h2>
              </>
            );
            setPlacement(message);
          }
          setShowModal(true);
          setSubmitting(false);
        }
      }
    } catch (error) {
      if (error?.code === "J3") {
        const message = (
          <>
            Riciesta eseguita dopo il termine temporale di validità delle
            prenotazioni associate.
          </>
        );
        setPlacement(message);
      } else if (error?.code === "J4") {
        setPlacement("Impossibile raggiungere il sistema di pagamento");
      } else {
        setPlacement("Servizio attualmente non disponibile");
      }
      queryClient.invalidateQueries(["cart", userProfile?.username]);
      setSubmitting(false);
      setShowModal(true);
    }
  };

  return (
    <>
      <Seo title="Completa l'acquisto" />
      <Header data={breadcrumbs} />
      <Breadcrumbs data={breadcrumbs} />
      <div role="main" className="main-wrapper  mt-3" id="main">
        <div className="container-lg">
          <div className="row">
            <div className="col-12">
              <h1>Completa l'acquisto</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Steps selected={2} />
            </div>
          </div>
          {isLoading && (
            <div className="row">
              <div className="col-12">
                <div className="text-center my-5">
                  <Icon name="spinner" className="icon--big icon--animated" />
                </div>
              </div>
            </div>
          )}

          <>
            {cart && (
              <div className="cart bg-gray px-4 py-5 mb-4">
                {isBookFail && (
                  <div className="row">
                    <div className="col-12 text-center">
                      <Icon name="alert" className="me-3" />
                      <strong>
                        Attenzione nel tuo carrello hai delle prenotazioni
                        scadute. Prima di procedere devi rimuoverle
                      </strong>
                    </div>
                  </div>
                )}

                <form
                  onSubmit={handleSubmit}
                  name="acquista"
                  method="post"
                  className="cart__form"
                >
                  <div className="row mt-4">
                    {mode === ECOMMERCE_MODE && (
                      <div className="col-12">
                        <h2 className="h3 graphic">
                          <span className="graphic__label graphic__label--gray-light">
                            Prenotazioni
                          </span>
                          <span className="graphic__line">&nbsp;</span>
                        </h2>

                        <div className="row">
                          <div className="col-12">
                            {cart?.book.length > 0 ? (
                              <>
                                <div className="row">
                                  <div className="d-none d-md-block col-3">
                                    <strong>Evento</strong>
                                  </div>
                                  <div className="d-none d-md-block col-3">
                                    <strong>Periodo</strong>
                                  </div>
                                  <div className="d-none d-md-block  col-1 text-lg-center">
                                    <strong>Quantità</strong>
                                  </div>
                                  <div className="d-none d-md-block col-1 text-lg-center">
                                    <strong>Costo</strong>
                                  </div>
                                  <div className="d-none d-md-block  col-3 ">
                                    <strong>Intestatari</strong>
                                  </div>
                                  <div className="d-none d-md-block  col-1 text-lg-center">
                                    <strong>Rimuovi</strong>
                                  </div>
                                </div>
                                {cart?.book.map((item, index) => (
                                  <div
                                    className={classNames(
                                      "cart__row py-3",
                                      item.status === "fail" &&
                                        "cart__row--fail",
                                    )}
                                    key={index}
                                  >
                                    <div
                                      key={item.id_book}
                                      className="row mb-2"
                                    >
                                      <div className="col-12 col-md-3">
                                        <Link
                                          to={`${linkProgramma}/${slugifyEventTitle(
                                            item.titolo,
                                          )}`}
                                        >
                                          {item.titolo}
                                        </Link>
                                        {item.status === "fail" && (
                                          <span className="badge badge--small badge--gray mx-2">
                                            scaduta
                                          </span>
                                        )}
                                      </div>
                                      <div className="col-12 col-md-3">
                                        {getDayDesc(item.data_book)} -{" "}
                                        {item.orario_book}
                                      </div>
                                      <div className="col-12 col-md-1 text-lg-center">
                                        <span className="d-inline d-md-none">
                                          Quantità:{" "}
                                        </span>
                                        {item.num_book}
                                      </div>
                                      <div className="col-12 col-md-1 text-lg-center">
                                        <span className="d-inline d-md-none">
                                          Costo:{" "}
                                        </span>
                                        {Number(item.num_book) -
                                          Number(item.num_book_free)}{" "}
                                        €
                                      </div>
                                      <div className="col-12 col-md-3">
                                        <span className="d-inline d-md-none">
                                          Intestatari:{" "}
                                        </span>
                                        {item.titoli?.[0].codice ===
                                        "esente" ? (
                                          <em>
                                            Evento gratuito senza intestatari
                                          </em>
                                        ) : (
                                          <>
                                            {item.titoli.map(
                                              (titolo, index) => {
                                                const codice =
                                                  titolo.codice?.split("#")[0];
                                                const titoloInfo =
                                                  cart?.titoli.find(
                                                    (t) =>
                                                      t.barcode === codice ||
                                                      t.pin_pratica === codice,
                                                  );
                                                return (
                                                  <React.Fragment key={index}>
                                                    {titoloInfo ? (
                                                      <>
                                                        {
                                                          titoloInfo
                                                            .intestatario.nome
                                                        }{" "}
                                                        {
                                                          titoloInfo
                                                            .intestatario
                                                            .cognome
                                                        }
                                                        {titoloInfo.tck ===
                                                          "premium" && (
                                                          <span className="badge badge--small mx-2">
                                                            premium
                                                          </span>
                                                        )}
                                                        {index <
                                                          item.titoli.length -
                                                            1 && (
                                                          <span className="d-inline d-md-none">
                                                            ,{" "}
                                                          </span>
                                                        )}
                                                        <br className="d-none d-md-block" />
                                                      </>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </React.Fragment>
                                                );
                                              },
                                            )}
                                          </>
                                        )}
                                      </div>
                                      <div className="col-12 col-md-1 text-lg-center">
                                        <button
                                          className="btn"
                                          disabled={removing}
                                          onClick={(e) =>
                                            onRemoveBooking(item.id_slot)
                                          }
                                          type="button"
                                        >
                                          <Icon name="trash" />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <div className="cart__row">
                                <div className="row  my-3">
                                  <div className="col-sm-12">
                                    Nessuna prenotazione nel carrello
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="col-12">
                      {cart?.book.length > 0 && (
                        <div className="row">
                          <div className="col-md-10 offset-md-1">
                            <h2 className="my-5">
                              Totale prenotazioni:{" "}
                              {(cart?.costo?.costo_tot || 0).toLocaleString(
                                "it",
                              )}{" "}
                              euro
                            </h2>
                            <button
                              id="acquista"
                              className="btn btn--link"
                              type="submit"
                              disabled={isBookFail || submitting}
                            >
                              {submitting && (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              )}{" "}
                              {cart?.costo?.costo_tot ? "Acquista" : "Conferma"}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            )}
            <Modal
              show={showModal}
              onHide={onHide}
              placement={placement}
              className="modal__internal d-flex flex-column"
              aria-labelledby="modal-label"
            >
              <>
                <button
                  aria-label="close"
                  className="modal__close"
                  onClick={onHide}
                >
                  <Icon className="ms-2" name="xmark" />
                </button>
                <div className="m-auto text-center">{placement}</div>
              </>
            </Modal>
          </>
        </div>
      </div>
    </>
  );
};
export default Carrello;
